// Plain tree constants, kept free of `three` imports so 2D consumers
// (e.g. components/Tree/TreeDrawer) can read them without pulling the 3D
// engine into the entry chunk. BuildTreeMeshes3D re-exports these.

export const CROWN_MESH_NAME = 'tree-crown';

export const TREE_CONFIG = {
	// Trunk
	trunkRadiusRatio: 0.10, // 10% of crown radius
	trunkHeightRatio: 1.665, // 50% of total height (totalHeight = crownRadius * 3.33)
	trunkSegmentsRadial: 8,
	trunkColor: 0x6b3a2a,

	// crown
	crownHeightRatio: 1.0, // 50% of crown diameter (i.e. = crown radius)
	crownSegmentsWidth: 12,
	crownSegmentsHeight: 12,
	crownColor: 0x2d5a1b,
	crownHighlightColor: 0x4a7c2f,
	crownHoverColor: 0x5a8f35,
	crownOpacity: 0.9,
	crownOffset: 0.2,
};
